<template>
  <div v-loading="loading" class="mobile-cam-container">
    <div class="page-header">
      <div class="title-section">
        <h2 class="page-title">我的监控</h2>
        <span class="online-status-text">
          在线 <span class="count-highlight">{{ onlineCount }}</span> / {{ dataList.length }}
        </span>
      </div>
      <i class="el-icon-plus-circle-outline add-icon-btn" @click="onAddDevice" />
    </div>

    <div class="cam-list">
      <div
        v-for="item in dataList"
        :key="item.id"
        class="mobile-cam-card"
        @click="handlePlay(item)"
      >
        <div class="cam-preview-wrapper">
          <div class="cam-placeholder">
            <i class="el-icon-video-camera" />
          </div>

          <div class="play-btn-mask">
            <i class="el-icon-video-play play-icon" />
          </div>

          <div class="status-indicator" :class="{ 'is-online': item.state }">
            <span class="dot" />
            {{ item.state ? '在线' : '离线' }}
          </div>
        </div>

        <div class="cam-content">
          <div class="cam-info-block">
            <h3 class="cam-name">{{ item.camName }}</h3>
            <p class="cam-id">ID: {{ item.camId }}</p>
          </div>

          <div class="cam-manage-block" @click.stop="handleSetting(item)">
            <i class="el-icon-setting mobile-setting-icon" />
          </div>
        </div>
      </div>
    </div>

    <el-empty v-if="dataList.length === 0 && !loading" description="暂无绑定设备" :image-size="120" />

    <div class="fab-add-btn" @click="onAddDevice">
      <i class="el-icon-plus" />
    </div>
  </div>
</template>

<script>
import { getCamList } from '@/api/disk'

export default {
  name: 'CamListMobile',
  data() {
    return {
      dataList: [],
      loading: false
    }
  },
  computed: {
    onlineCount() {
      return this.dataList.filter(i => i.state).length
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      getCamList().then(resp => {
        if (resp.code === 0) {
          this.dataList = resp.data
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handlePlay(item) {
      if (!item.state) {
        this.$message.warning('设备已离线，无法查看实时画面')
        return
      }
      this.$router.push({
        path: '/disk/cam/detail',
        query: { camId: item.camId }
      })
    },
    handleSetting(item) {
      this.$message.info(`打开设备 [${item.camName}] 的设置`)
      // 实际开发跳转至设置路由或打开 Dialog
    },
    onAddDevice() {
      this.$message.info('去往添加设备页面')
    }
  }
}
</script>

<style scoped>
.mobile-cam-container {
  padding: 12px 16px 80px 16px; /* 为底部导航栏和悬浮按钮预留空间 */
  background: #f8f9fa;
  min-height: calc(100vh - 100px);
}

/* 顶部轻量头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  font-size: 20px;
  font-weight: bold;
  color: #1a1a1a;
  margin: 0;
}

.online-status-text {
  font-size: 12px;
  color: #7d7e80;
  margin-left: 8px;
}

.count-highlight {
  color: #67c23a;
  font-weight: bold;
}

.add-icon-btn {
  font-size: 24px;
  color: #1a73e8;
  padding: 4px;
}

/* 移动端专用单列流布局卡片 */
.cam-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.mobile-cam-card {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.02);
  -webkit-tap-highlight-color: transparent; /* 清除点击高亮 */
}

/* 触发点击反馈效果 */
.mobile-cam-card:active {
  background-color: #f5f5f5;
  transform: scale(0.99);
  transition: all 0.1s ease;
}

/* 16:9 标准比例视频容器 */
.cam-preview-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9; /* 完美符合现代摄像头画面 */
  background: linear-gradient(135deg, #2c3e50 0%, #111 100%);
}

.cam-placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cam-placeholder i {
  font-size: 40px;
  color: rgba(255, 255, 255, 0.15);
}

/* 常驻轻量中心播放徽标 */
.play-btn-mask {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.1);
}
.play-icon {
  font-size: 36px;
  color: rgba(255, 255, 255, 0.8);
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

/* 状态指示器样式轻量化 */
.status-indicator {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 2px 8px;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  border-radius: 12px;
  color: #fff;
  font-size: 10px;
  display: flex;
  align-items: center;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 4px;
  background: #f56c6c;
}

.is-online .dot {
  background: #67c23a;
  box-shadow: 0 0 6px #67c23a;
}

/* 信息控制栏区 */
.cam-content {
  padding: 12px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cam-name {
  font-size: 15px;
  font-weight: bold;
  color: #333333;
  margin: 0 0 2px 0;
}

.cam-id {
  font-size: 11px;
  color: #999999;
  margin: 0;
}

/* 移动端加大点击半径的控制块 */
.cam-manage-block {
  padding: 10px; /* 增加手指触控面积 */
  margin-right: -4px;
}

.mobile-setting-icon {
  font-size: 20px;
  color: #606266;
}

/* 右下角悬浮动作添加按钮（FAB） */
.fab-add-btn {
  position: fixed;
  bottom: 80px; /* 避开底部的 Tabbar */
  right: 20px;
  width: 50px;
  height: 50px;
  background: #1a73e8;
  border-radius: 50%;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.4);
  z-index: 99;
}
.fab-add-btn:active {
  background: #155cb8;
}
</style>
